// photos functions

// usage like:
// >> import photos from "@/photos";
// >> photos.uploadPhoto(e, store, callback, dir, filename, businessID);
// returns: "mon"

import imageCompression from "browser-image-compression";

var photos = {
  // // example callback
  // attachReceiptToOrder(picURL) {
  //   var loader = this.loadingDots("lightgreen");
  //   this.$store
  //     .dispatch("patchTransaction", {
  //       transactionID: this.orderID,
  //       data: {
  //         data: { payment_receipt_pic: picURL },
  //       },
  //     })
  //     .then(() => {
  //       this.successToast("Payment Receipt Uploaded");
  //       this.log("upload_payment_receipt_success", this.orderID);
  //       this.$emit("update");
  //       this.close();
  //     })
  //     .catch((err) => this.apiError(err))
  //     .finally(() => loader.hide());
  // },
  uploadPhoto(e, store, callback, dir, filename, businessID) {
    if (!e.target.files || !e.target.files.length) return;
    var originalFile = e.target.files[0];

    // var loader = this.loadingDots();
    var options = {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 700,
      useWebWorker: true,
    };
    imageCompression(originalFile, options)
      .then((compressedFile) => {
        var sizeKB = Math.round(compressedFile.size / 1024);
        console.log(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

        imageCompression
          .getDataUrlFromFile(compressedFile)
          .then((base64) => {
            var data = {
              name: `${filename}.png`,
              content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
              businessID: businessID,
              imageType: dir, //"receipt",
            };
            store
              .dispatch("uploadImageAWS", data)
              .then((res) => {
                console.log("uploadImageAWS", res.data);
                var picURL = res.data.compressed_image_url; //JSON.parse(res.data.body).Location;
                callback(picURL); // this.attachReceiptToOrder(picURL);
              })
              .catch((err) => this.apiError(err));
            // .finally(() => loader.hide());
          })
          .catch((err) => console.log("imageData error", err));
      })
      .catch((err) => console.log("imageCompression error", err));
  },
};

export default photos;
